'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordChange = undefined;

var _PasswordChange2 = require('./PasswordChange');

var _PasswordChange3 = _interopRequireDefault(_PasswordChange2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PasswordChange = _PasswordChange3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordChange/index.js
// module id = 1733
// module chunks = 0